import { logger } from "@origin-digital/reporting-client";
import { getOriginCustomerId } from "@origin-digital/auth-utils";
import { fetchAccessToken, authUser } from "@origin-digital/event-dispatcher";
import { fetchUserHash } from "./userHash";
import { IIntercomSettings, initIntercom } from "./initialize";

interface IUserInfo {
  userHash: string;
  userId: string;
}

// TODO: This check will be moved to the page manifest of tal apps (P21-579)
export function shouldInitialize(): boolean {
  const platformApps = [
    "/auth/callback",
    "/logout",
    "/auth/ml",
    "/auth/sml",
    "/my-account/contexthub",
  ];
  const pathName = window.location.pathname;

  return !platformApps.some(
    (app) => app === pathName || pathName.startsWith("/my/")
  );
}

async function isAuthenticated() {
  const authInfo = await authUser({});
  return authInfo ? authInfo.isAuth : false;
}

export async function getUserInfo(): Promise<IUserInfo | undefined> {
  try {
    const result = await fetchAccessToken({});

    if (result && result.accessToken) {
      const userId = getOriginCustomerId(result.accessToken);
      const { userHash } = await fetchUserHash("WEB", false);
      return userId && userHash ? { userId, userHash } : undefined;
    } else {
      logger.debug("[od/chat] getUserInfo:: accessToken is undefined");
      return undefined;
    }
  } catch (e) {
    logger.error("[od/chat] getUserInfo failed");
    return undefined;
  }
}

export async function initWebChat(settings?: IIntercomSettings): Promise<void> {
  if (!shouldInitialize()) {
    // Do not initialise for platform specific and kraken apps
    return;
  }
  const isAuth = await isAuthenticated();
  if (!isAuth) {
    // when unauthenticated, install settings for visitors/leads
    return initIntercom(settings);
  }
  const userInfo = await getUserInfo();
  // eslint-disable-next-line no-negated-condition
  if (!userInfo) {
    // when userId or userHash is missing, install settings for visitors/leads
    return initIntercom(settings);
  } else {
    // when userId and userHash are present, install settings for users
    return initIntercom({
      ...settings,
      user_id: userInfo.userId,
      user_hash: userInfo.userHash,
    });
  }
}
